import { Inject, Injectable } from "@angular/core";
import { DOCUMENT } from "@angular/common";
import { AuthService } from "./auth.service";
import { Subject } from "rxjs";
const MINUTES_UNITL_AUTO_LOGOUT = 60 // in mins
const CHECK_INTERVAL = 15000 // in ms
const STORE_KEY =  'lastAction';

@Injectable()
export class InactivityMonitorService {

    public timeout: Subject<boolean> = new Subject();

    public readyInterval: number;

    public checkInterval: number;

    constructor (
        private authService: AuthService,
        @Inject(DOCUMENT) private document: Document
    ) {

        this.check();
        this.initInterval();
        localStorage.setItem(STORE_KEY, Date.now().toString());
        
        this.readyInterval = window.setInterval(() => {

            if (this.document.readyState === 'complete') {

                this.initListeners();
                window.clearInterval(this.readyInterval);
            }
        }, 200);
    }

    public getLastAction () {

        return parseInt(localStorage.getItem(STORE_KEY));
    }

    initListeners () {

        this.document.body.addEventListener('click', this.reset);
        this.document.body.addEventListener('mouseover', this.reset);
        this.document.body.addEventListener('mouseout', this.reset);
        this.document.body.addEventListener('keydown', this.reset);
        this.document.body.addEventListener('keyup', this.reset);
        this.document.body.addEventListener('keypress', this.reset);
    }

    reset () {

        localStorage.setItem(STORE_KEY, Date.now().toString());
    }

    initInterval () {

        this.checkInterval = window.setInterval(
            () => {

                this.check();
            },
            CHECK_INTERVAL
        );
    }

    check () {

        const now = Date.now();
        const timeLeft = this.getLastAction() + MINUTES_UNITL_AUTO_LOGOUT * 60 * 1000;
        const diff = timeLeft - now;
        const isTimeout = diff < 0;

        if (isTimeout) {

            this.authService.loggedIn()
                .subscribe(
                    result => {

                        if (result) {

                            this.authService.logout()
                                .subscribe (
                                    () => {
                                        
                                        this.timeout.next(true);
                                    }
                                );
                        }
                    }
                );
        }
    }

    cleanUp () {

        window.clearInterval(this.checkInterval);

        this.document.body.removeEventListener('click', this.reset);
        this.document.body.removeEventListener('mouseover', this.reset);
        this.document.body.removeEventListener('mouseout', this.reset);
        this.document.body.removeEventListener('keydown', this.reset);
        this.document.body.removeEventListener('keyup', this.reset);
        this.document.body.removeEventListener('keypress', this.reset);
    }
}